
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"70.296","height":"53.475","viewBox":"1.366 18.603 70.296 53.475"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2CA386","d":"M71.076 25.509a2 2 0 010 2.829L27.923 71.491a2 2 0 01-2.829 0L1.952 48.348a2 2 0 010-2.828l6.321-6.321a2.001 2.001 0 012.828 0l13.993 13.993a2 2 0 002.829 0l34.003-34.003a2 2 0 012.829 0l6.321 6.32z"}})])
          )
        }
      }
    